import { safeboxClient } from 'myNet'

const ROUTE = '/v1/favorites'

interface ApiResponse<T = any> {
  code: number
  message: string
  data?: T
}

interface ErrorWithCode extends Error {
  code: number
}

interface CreateRequest {
  [key: string]: any
}

interface DeleteRequest {
  id: string
}

const FavoritesService = {
  post: async (request: CreateRequest): Promise<ApiResponse> => {
    const response = await safeboxClient.post(`${ROUTE}`, request)
    const { code, message } = response.data
    if (code !== 200) {
      const err = new Error(message) as ErrorWithCode
      err.code = code
      throw err
    }
    return response.data
  },
  delete: async ({ id }: DeleteRequest): Promise<ApiResponse> => {
    const response = await safeboxClient.delete(`${ROUTE}/${id}`)
    const { code, message } = response.data
    if (code !== 200) {
      const err = new Error(message) as ErrorWithCode
      err.code = code
      throw err
    }
    return response.data
  },
  get: async (request?: any): Promise<ApiResponse> => {
    const response = await safeboxClient.get(`${ROUTE}`, request)
    const { code, message } = response.data
    if (code !== 200) {
      const err = new Error(message) as ErrorWithCode
      err.code = code
      throw err
    }
    return response.data
  },
}

export default FavoritesService
